import {CommonModule} from '@angular/common';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatBadgeModule} from '@angular/material/badge';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatChipsModule} from '@angular/material/chips';
import {MatDialogModule} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';

import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatTabsModule} from '@angular/material/tabs';

import {RouterModule, Routes} from '@angular/router';
import {NgSelectModule} from '@ng-select/ng-select';
import {TranslateModule} from '@ngx-translate/core';

import {SharedModule} from '@atmi/shared';
import {UiModule} from '@ui/ui.module';

import {PeopleFiltersComponent} from './components/people-filters/people-filters.component';
import {PeopleComponent} from './components/people/people.component';
import {PersonContactFormComponent} from './components/person-contact-form/person-contact-form.component';
import {PersonManagerComponent} from './components/person-manager/person-manager.component';
import {PersonModuleConfiguration} from './models/configuration';
import {PersonConfigurationService} from './token';

export * from './components/people/people.component';
export * from './components/person-manager/person-manager.component';
export * from './models/configuration';
export * from './models/person';
export * from './token';

const routes: Routes = [
  {
    children: [
      {
        component: PeopleComponent,
        path: '',
      },
    ],
    path: '',
  },
];

const MATERIAL = [
  MatBadgeModule,
  MatButtonModule,
  MatCardModule,
  MatCardModule,
  MatChipsModule,
  MatDialogModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatSelectModule,
  MatTabsModule,
];

@NgModule({
  declarations: [
    PeopleComponent,
    PeopleFiltersComponent,
    PersonContactFormComponent,
    PersonManagerComponent,
  ],
  exports: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    UiModule,
    TranslateModule,
    NgSelectModule,
    ...MATERIAL,
  ],
})
export class PersonModule {
  static forRoot(config: PersonModuleConfiguration): ModuleWithProviders<PersonModule> {
    return {
      ngModule: PersonModule,
      providers: [
        {provide: PersonConfigurationService, useValue: config},
      ],
    };
  }
}
